/**
 * Shared `session/update` handling: config_option_update (persist only) and load-replay suppression.
 */

export type SessionUpdateDispatchOpts = {
  /** Flat or inner update object with `sessionUpdate` / `session_update` at top level. */
  flatPayload: Record<string, unknown>;
  onAcpConfigOptionsUpdated?: (configOptions: unknown[]) => void;
  onSessionUpdate?: (payload: unknown) => void;
  suppressLoadReplay: () => boolean;
};

/** Forwards to `onSessionUpdate` unless this is a config-only update or load replay suppression applies. */
export function dispatchAcpSessionUpdate(opts: SessionUpdateDispatchOpts): void {
  const { flatPayload, onAcpConfigOptionsUpdated, onSessionUpdate, suppressLoadReplay } = opts;
  const su = flatPayload.sessionUpdate ?? flatPayload.session_update;
  if (su === 'config_option_update') {
    const co = flatPayload.configOptions;
    if (Array.isArray(co)) onAcpConfigOptionsUpdated?.(co);
    return;
  }
  if (suppressLoadReplay()) return;
  onSessionUpdate?.(flatPayload);
}
